import React from 'react'
import { motion } from "framer-motion";
import { Col, Row, Container } from 'react-bootstrap';
import { GrReactjs, GrCode } from "react-icons/gr"
import { SiAdobexd } from 'react-icons/si'

const containerVariants = {
	initial: {
		x: '-100vw',
		opacity: 0,
	},
	animate: {
		opacity: 1,
		x: 0,
		transition: {
			type: 'spring'
		}
	},
	exit: {
		x: '50vw',
		opacity: 0,
		transition: {
			duration: 0.5
		}
	}
}

const aboutCategoryBoxVariant = {
	hover: {
		boxShadow: '5px 6px 20px 0px #989898'
	}
}

const aboutCategoryBoxVariantContainer = {
	initial: {
		x: '-100vw',
		opacity: 0,
	},
	animate: {
		opacity: 1,
		x: 0,
		transition: {
			type: 'spring'
		}
	},
}

const About = () => {
	return (
		<motion.section className="d-flex flex-column align-items-center justify-content-center" id='about'
			variants={containerVariants}
			initial="initial"
			animate="animate"
			exit="exit"
		>
			<div className="about-info-box">
				<Container>
					<Row className="font-poppins">
						<Col xs={12} sm={6}>
							<Row>
								<Col xs={4} className="text-right font-weight-bold" style={{ fontSize: 38 }}>
									5
								</Col>
								<Col xs={8} className="text-left">
									Years of<br />Experience
								</Col>
							</Row>
						</Col>
						<Col xs={12} sm={6}>
							<Row>
								<Col xs={4} className="text-right font-weight-bold" style={{ fontSize: 38 }}>
									14
								</Col>
								<Col xs={8} className="text-left">
									Projects<br />Completed
								</Col>
							</Row>
						</Col>
					</Row>
				</Container>
			</div>
			<div style={{ height: '100px', width: '100vw' }} className="d-block d-lg-none"></div>
			<Container>
				<div style={{ paddingTop: 30 }}>
					<Row>
						<Col className="text-left font-poppins" xs={12} md={6}>
							<motion.div
								variants={aboutCategoryBoxVariantContainer}
								initial="initial"
								animate="animate"
							>
								<a className="about-cat-box-link" target="_blank" href="https://www.behance.net/itsvishalcodes">
									<motion.div className="about-category-box"
									variants={aboutCategoryBoxVariant}
									whileHover="hover"
								>
									<Row>
										<Col xs={10}>
											<div className="about-category-box-heading">Design</div>
											<div className="about-category-box-info">I design UI/UX rich apps with Figma</div>
											<div className="about-category-box-number">7 PROJECTS</div>
										</Col>
										<Col className="d-flex justify-content-center align-items-center" xs={2}>
												<SiAdobexd size={24} color="#000" />
										</Col>
									</Row>
								</motion.div>
								</a>
								<a className="about-cat-box-link" target="_blank" href="https://www.behance.net/itsvishalcodes">
									<motion.div className="about-category-box"
										variants={aboutCategoryBoxVariant}
										whileHover="hover"
									>
										<Row>
											<Col xs={10}>
												<div className="about-category-box-heading">Web Development</div>
												<div className="about-category-box-info">I create Full Stack Web Apps using MERN Stack</div>
												<div className="about-category-box-number">5 PROJECTS</div>
											</Col>
											<Col className="d-flex justify-content-center align-items-center" xs={2}>
												<GrReactjs size={24} color="#000" />
											</Col>
										</Row>
									</motion.div>
								</a>
								<a className="about-cat-box-link" target="_blank" href="https://play.google.com/store/apps/developer?id=Vishal+Codes">
									<motion.div className="about-category-box"
										variants={aboutCategoryBoxVariant}
										whileHover="hover"
									>
										<Row>
											<Col xs={10}>
												<div className="about-category-box-heading">App Development</div>
												<div className="about-category-box-info">I code Platform Independent Apps using both React Native and Flutter</div>
												<div className="about-category-box-number">2 PROJECTS</div>
											</Col>
											<Col className="d-flex justify-content-center align-items-center" xs={2}>
												<GrCode size={24} color="#000" />
											</Col>
										</Row>
									</motion.div>
								</a>
							</motion.div>
						</Col>
						<div style={{ height: '100px', width: '100vw' }} className="d-block d-lg-none"></div>
						<Col xs={12} md={6}>
							<div className="text-left about-intro-box font-poppins">
								<h2 className="about-intro-box-heading font-weight-bold">Introduction</h2>
								<div className="about-intro-box-info">
									I am an Intermediate Programmer who started coding 5 years ago when I was in Class IX. I can't say if I have learnt alot, but I gained alot of exposure overtime, which only time and practise could have provided.
									<br/><br/>
									Currently, I am in 2nd year of Computer Science Engineering looking forward to learn as much as I can. Coding is something I love alot from the very beginning when I started it. Nothing can be better than commanding a machine to do something for you. This very thing made me fall in love with it. ;)
								</div>
							</div>
						</Col>
					</Row>
				</div>
			</Container>
		</motion.section>
	)
}

export default About;